import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import CollectionComponent from '../../components/collection/Collection';

import { getCollectionFlow } from 'api/game';

const Collection: React.FC = () => {
  const { collectionId } = useParams();

  useEffect(() => {
    getCollectionFlow(collectionId);
  }, []);

  return <CollectionComponent />;
};

export default Collection;
